"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ModalDialog = _interopRequireDefault(require("../../components/modal/ModalDialog"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _index = require("../../index");

var _SendNotificationModel = _interopRequireDefault(require("./models/SendNotificationModel"));

var _AppSelect = _interopRequireDefault(require("../../components/crud/AppSelect"));

var _TargetUsers = _interopRequireDefault(require("./components/TargetUsers"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AddNewPush = /*#__PURE__*/function (_React$Component) {
  _inherits(AddNewPush, _React$Component);

  function AddNewPush() {
    var _this;

    _classCallCheck(this, AddNewPush);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddNewPush).call(this)); // Initial state

    _this.formHandler = new _index.FormHandler(_assertThisInitialized(_this), new _SendNotificationModel["default"]({
      name: '',
      title: '',
      text: '',
      type: 'promotional',
      icon: 'info',
      sendTo: 'all',
      action: '',
      actionPayload: {},
      filter: {}
    }), {
      showModal: false
    });
    return _this;
  }

  _createClass(AddNewPush, [{
    key: "openModal",
    value: function openModal(e) {
      e.preventDefault();
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {// $(this.refs.element)
      //   .find("select")
      //   .select2({
      //     minimumResultsForSearch: -1
      //   });
      // $("#datetimepicker1").datetimepicker();
      // $("#datetimepicker2").datetimepicker();
    }
  }, {
    key: "_getNotificationTypeOptions",
    value: function _getNotificationTypeOptions() {
      return [{
        id: 'promotional',
        name: 'Promotional'
      }, {
        id: 'system',
        name: 'System'
      }];
    }
  }, {
    key: "_getNotificationIconOptions",
    value: function _getNotificationIconOptions() {
      return [{
        id: 'info',
        name: 'Info'
      }, {
        id: 'danger',
        name: 'Danger'
      }];
    }
  }, {
    key: "_getTargetOptions",
    value: function _getTargetOptions() {
      return [{
        id: 'all',
        name: 'All users'
      }, {
        id: 'one',
        name: 'Specific user'
      }, {
        id: 'test_groups',
        name: 'Test groups'
      }, {
        id: 'group',
        name: 'User group'
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var formHandler = this.formHandler;
      return _react["default"].createElement("div", {
        className: "credit-card-management"
      }, _react["default"].createElement("h1", null, _react["default"].createElement("i", {
        className: "fa fa-bell",
        "aria-hidden": "true"
      }), " Notifications"), _react["default"].createElement("div", {
        className: "element-with-blur"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header"
      }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
        className: "fa fa-plus"
      }), " Send New Notification", ' ')), _react["default"].createElement("div", {
        className: "add-new-group",
        ref: "element"
      }, _react["default"].createElement(_index.FormSubmitWrapper, {
        formHandler: formHandler,
        to: "/push-notifications",
        buttonText: "Send"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement("h4", null, "Basic info"), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        customInput: _TextField["default"],
        label: "Notification name",
        note: "Note: this won't be visible by end users",
        type: "text",
        name: "name",
        value: this.state.record.name,
        handler: formHandler
      }), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        customInput: _TextField["default"],
        label: "Notification title",
        type: "text",
        name: "title",
        value: this.state.record.title,
        handler: formHandler
      }), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        customInput: _TextField["default"],
        label: "Notification text",
        type: "textarea",
        name: "text",
        value: this.state.record.text,
        handler: formHandler
      }), _react["default"].createElement("h4", {
        style: {
          marginTop: 40
        }
      }, "Extra fields"), _react["default"].createElement(_AppSelect["default"], {
        textFieldProps: {
          label: 'Notification type',
          InputLabelProps: {
            shrink: true
          }
        },
        options: this._getNotificationTypeOptions(),
        name: "type",
        value: this.state.record.type,
        handler: formHandler,
        placeholder: "Notification type"
      }), _react["default"].createElement(_AppSelect["default"], {
        textFieldProps: {
          label: 'Notification icon',
          InputLabelProps: {
            shrink: true
          }
        },
        options: this._getNotificationIconOptions(),
        name: "icon",
        value: this.state.record.icon,
        handler: formHandler,
        placeholder: "Notification icon"
      })), _react["default"].createElement("div", {
        className: "col-md-6 col-md-offset-1 user-group-filters"
      }, _react["default"].createElement("h4", null, "Target users"), _react["default"].createElement(_AppSelect["default"], {
        textFieldProps: {
          label: 'Send to',
          InputLabelProps: {
            shrink: true
          }
        },
        options: this._getTargetOptions(),
        name: "sendTo",
        value: this.state.record.sendTo,
        handler: formHandler,
        placeholder: "Notification icon"
      }), _react["default"].createElement(_TargetUsers["default"], {
        formHandler: formHandler,
        sendTo: this.state.record.sendTo
      })))))), _react["default"].createElement(_ModalDialog["default"], {
        show: this.state.showModal,
        onClose: this.onClose.bind(this),
        style: {
          position: 'relative',
          backgroundColor: 'transparent'
        }
      }, _react["default"].createElement("img", {
        src: "/img/push-notification.png",
        alt: "",
        style: {
          maxHeight: '500px',
          display: 'block',
          margin: 'auto'
        }
      })));
    }
  }]);

  return AddNewPush;
}(_react["default"].Component);

exports["default"] = AddNewPush;